<template>
  <div class="w-100 p-r f-row-c overf-h" @click.top="onPlay" v-if='!itemPlayTip'>
    <img src='@/assets/img/video/video_icon.png' class="video_icon" v-if='!playTip'/>
    <video :src='this.$imgUrl+file' class="w-100" :controls='playTip' ref='myFile'></video>
  </div>
</template>

<script>
export default {
  name: 'videoBox',
  props: ['file','index','itemPlayTip'],
  data() {
    return {
      playTip: false,
      isShow:true,
    };
  },
  watch:{ 
    'itemPlayTip': {
      handler (newName, oldName) {
        // this.playTip=newName
        // console.log('newName',newName)
        // if (newName) {
        //   this.$refs.myFile.play()
        // } else {
        //   this.$refs.myFile.pause()
        // }
      }

    }
  },
  mounted() {
    // this.playTip=this.itemPlayTip
  },

  methods: {
    onClose(){
      this.$refs.myFile.pause()
    },
    onPlay() {
      this.playTip = !this.playTip
      console.log('playTip',this.playTip)
      // this.$emit('onChangeVideo', {playTip:this.playTip,index:this.index});
      if (this.playTip) {
        this.$refs.myFile.play()
      } else {
        this.$refs.myFile.pause()
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>